exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3wBKpPYkzIctGJaYbD3AwM{text-decoration:inherit;color:\"[theme:black, default:#000000]\"}html[dir] ._3wBKpPYkzIctGJaYbD3AwM{border-radius:2px;padding:0 1px;background-color:\"[theme:neutralLighter, default:#f4f4f4]\"}html[dir] ._3wBKpPYkzIctGJaYbD3AwM:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}", ""]);

// exports
exports.locals = {
	"mentionsCompose": "_3wBKpPYkzIctGJaYbD3AwM"
};